import axios from "axios"

const AGENT_SESSION_PATH = "/dash/agent_auth/session"

export async function requestChatGrant() {
    // The empty object is not ceremony: dash_api parses the body before it routes, and answers
    // "Could not parse an empty JSON body" when axios sends the request without one.
    let response = await axios.post(AGENT_SESSION_PATH, {})
    let grant = (response.data || {}).grant
    if (!grant) {
        throw new Error("Agent auth session responded without a grant")
    }
    return grant
}
